import { render, staticRenderFns } from "./ListLiveTutorialsTable.vue?vue&type=template&id=a587278c"
import script from "./ListLiveTutorialsTable.vue?vue&type=script&lang=js"
export * from "./ListLiveTutorialsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports